import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { compose } from 'redux';
import { Flex } from 'nallian-shared-ui/lib/components';
import NotificationSettingsForm from './NotificationSettingsForm';
import notificationSettingsService from '../../services/notifications/notificationSettingsService';
import updateNotificationSettingsService from '../../services/notifications/updateNotificationSettingsService';

const NotificationSettings = ({
  dispatchNotificationSettingsGet,
  notificationSettingsFetch,
  dispatchUpdateNotificationSettingsPut,
  updateNotificationSettingsFetch,
}) => {
  const { id } = useParams();
  const { t } = useTranslation();

  useEffect(() => dispatchNotificationSettingsGet(id), [dispatchNotificationSettingsGet, id]);

  const handleSaveNotificationSettings = useCallback(
    values => dispatchUpdateNotificationSettingsPut(id, values, t),
    [id, dispatchUpdateNotificationSettingsPut, t]
  );

  return (
    <Flex>
      <NotificationSettingsForm
        loading={notificationSettingsFetch.pending}
        submitting={updateNotificationSettingsFetch.pending}
        initialValues={notificationSettingsFetch.value}
        onSubmitForm={handleSaveNotificationSettings}
      />
    </Flex>
  );
};

NotificationSettings.propTypes = {
  dispatchNotificationSettingsGet: PropTypes.func.isRequired,
  notificationSettingsFetch: PropTypes.object.isRequired,
  dispatchUpdateNotificationSettingsPut: PropTypes.func.isRequired,
  updateNotificationSettingsFetch: PropTypes.object.isRequired,
};

export default compose(
  notificationSettingsService,
  updateNotificationSettingsService
)(NotificationSettings);
